import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContractTreeNodeV26 } from 'src/app/models-v26/contract-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { MoveBillingitemsDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/move-billingitems-wizard/activation-step/movebillingitems-due-date-info';
import { MoveBillingitemsInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/move-billingitems-wizard/init-step/init-step';
import * as fromMoveBillingitemsWizard from './reducer';
import { State } from './state';

export const selectMoveBillingitemsWizardState = createFeatureSelector<State>(fromMoveBillingitemsWizard.moveBillingitemsWizardFeatureKey);

export const selectInitStep = createSelector(
  selectMoveBillingitemsWizardState,
  (state: State): MoveBillingitemsInitStepV26 => state.initStep,
);

export const selectDueDateStep = createSelector(
  selectMoveBillingitemsWizardState,
  (state: State): MoveBillingitemsDueDatesV26 => state.dueDatesStep,
);

export const selectContractsStep = createSelector(
  selectMoveBillingitemsWizardState,
  (state: State): ContractTreeNodeV26[] => state.contractStep,
);

export const selectMoveBillingitemsState = createSelector(
  selectMoveBillingitemsWizardState,
  (state: State): ActionResponse => state.response,
);

export const selectErrorMessage = createSelector(selectMoveBillingitemsWizardState, (state: State): string => state.errorMessage);
